import $ from 'jquery';
import './modules/slider.js';
// import './modules/modaal.js';

$(function () {

    // nav-tabs
    $(document).on('click', '.tabs a', function (e) {
        e.preventDefault()
        let $this = $(this);
        if (!$this.parent().hasClass('active')) {
            $this.parent().siblings().removeClass('active')
            $this.parent().addClass('active')

            let target = $this.attr('href');
            $(target).siblings().removeClass('active')
            $(target).addClass('active');
        }
    });

    $('.btn-close-modal').on('click', function (e) {
        e.preventDefault();
        $(this).closest(".open").removeClass('open');
        $('body').toggleClass('modal-open')
    })

    $('.collapse-btn').on('click', function (e) {
        e.preventDefault()
        $(this).toggleClass('open')
        $(this).siblings('.collapse').slideToggle(200);
    })


    let hashTarget = window.location.hash
    if (hashTarget) {
        let currentOffset = $(window).scrollTop();
        let updateOffset = currentOffset - $('.main-header').height() - 40
        if (updateOffset < 500) {
            window.onload = function () {
                $(window).scrollTop(updateOffset)
            }
        } else {
            $(window).scrollTop(updateOffset)
        }
    }

    $('.go-to').on('click', function (e) {
        let target = $(this).attr('href')
        if (target[0] == '#') {
            e.preventDefault();
            goTo(target)
        } else {
            window.location.href = `/${target}`
        }


        function goTo(target, time = 300) {
            let targetPos = $(target).offset().top;
            let pos = targetPos;
            $('html, body').animate({
                scrollTop: pos
            }, time)
        }
    })

    $('.popup-close').on('click', function() {
        $('.modaal-inner-wrapper').trigger('click')
    })
    $('.type-b .form-submit.btn-blue2').on('click', function() {
        if($(window).innerWidth() > 768){
            $(this).addClass("hidden");
            $(this).parent().find(".btn-blue").removeClass("hidden");
        }
    })
    var date = new Date();
    var months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];;

    $(".js-year").html(date.getFullYear());
    $(".js-month").html(months[date.getMonth()]);
    $(".js-day").html(date.getDate());

    $('.js-collapse').on('click', function (e) {
        e.preventDefault()
        var target = $(this).attr("href");
        $(target).slideToggle(200);
    })
    $(document).on('click', '.ranking-tabs a', function (e) {
        e.preventDefault()
        var target = $(this).attr("href");
        $(this).closest(".ranking-tabs").find(".active").removeClass("active");
        $(this).closest("li").addClass("active");
        $(target).closest(".js-wrap").find(">.active").removeClass("active");
        $(target).addClass("active");
    });
})

// Back to top
// $(window).on('scroll', function () {
//     // Show button after 100px
//     var showAfter = 300;
//     if ($(this).scrollTop() > showAfter) {
//         $('.go-top').fadeIn();
//     } else {
//         $('.go-top').fadeOut();
//     }
// });

//Click event to scroll to top
$('.go-top').on('click', function () {
    $('html, body').animate({
        scrollTop: 0
    }, 800);
    return false;
});
$(window).on('scroll', function () {
    // Show button after 100px
    var fixed = $(".visual").outerHeight();
    if ($(this).scrollTop() > fixed) {
        $('.sidebar-box').addClass("ie-fixed");
    } else {
        $('.sidebar-box').removeClass("ie-fixed");
    }
});

$('.js-triggerTab1').on('click', function() {
    $('#ranking > div.ranking-content > div > ul li:first-child a').trigger('click')
})
$('.js-triggerTab2').on('click', function() {
    $('#ranking > div.ranking-content > div > ul li:nth-child(2) a').trigger('click')
})
$('.js-triggerTab3').on('click', function() {
    $('#ranking > div.ranking-content > div > ul li:nth-child(3) a').trigger('click')
})
